import React, { Component } from 'react';
import Rows from './Rows'
import './styles.css'

class ImportValidate extends Component {
    render() {
        return (
            <div id='import-validate'>
                <h3>Import Data Validate Result</h3>
                <h4>Header data uses <span className='header-line-count'>{this.props.headerLineCount}</span> line(s) in this import data</h4>
                <div className='contain-table'>
                <table className="tbl-grey">
                    <thead>
                        <tr>
                            <th style={{width:'9%'}}>Type</th>
                            <th style={{width:'6%'}}>Line</th>
                            <th style={{width:'32%'}}>Channel Order #</th>
                            <th style={{width:'18%'}}>Column</th>
                            <th style={{width:'35%'}}>Detail</th>
                        </tr>
                    </thead>
                    <Rows
                        listDataValidate={this.props.listDataValidate}
                    />
                </table>

                </div>
            </div>
        );
    }
}

export default ImportValidate;


// WEBPACK FOOTER //
// ./src/components/step-import-order/components/import-validate/index.js